import type { UseQueryResult } from 'react-query';
import { delay } from '@olivierpascal/helpers';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { IAuthUser } from '../AuthClient';
import type { IAuthCacheEntry } from '../cache';
import { useAuth } from './useAuth';

export const allCredentialsQueryKeyFactory: IQueryKeyFactory = () =>
  ['allCredentials'] as const;

export const useAllCredentialsQuery = (): UseQueryResult<
  Array<IAuthCacheEntry<IAuthUser>> | undefined
> => {
  const auth = useAuth();
  const allCredentialsQuery = useQuery({
    queryKey: allCredentialsQueryKeyFactory(),
    queryFn: () =>
      // If the query immediately return, there is a bug in Tanstack Query
      // that makes useIsFetching() not work properly.
      // Using delay() as a workaround.
      delay(300).then(() => auth.getClient().getAllCredentials()),
  });

  return allCredentialsQuery;
};
